export const pageWidth = '1000px';
export const backgroundColor = '#282c34';
export const textColor = 'white';
export const singleColumnWidth = '768px';
